import React, { useState, useEffect } from 'react';
import axios from "axios";
import { Link } from 'react-router-dom';

const BottomNav = () => {
    return (
        <div className="topnav">
            <div className="topnav__links">
                <a href="/">Home</a>
            </div>
        </div>
    );
}

export default BottomNav;